import { PapiUser } from '@wix/da-papi-types';
import { UserSymbol } from './types';
import { ResourceType } from '../types/resource';

/**
 * DO NOT USE THIS FOR ANYTHING OTHER THAN RENDERING THE SYMBOL
 * @deprecated not actually deprecated but you don't need this
 */
export function getUserSymbol({
  type,
  isGroup: userIsGroup,
}: PapiUser): UserSymbol {
  return userIsGroup ? 'group' : (type as UserSymbol);
}

/** Returns true if (gr)user is a group */
export function isGroup(user?: PapiUser): boolean {
  return user?.isGroup ?? false;
}

export const getIsGroup = isGroup;

/** Returns group or user type id based on given gruser */
export function getUserTypeId(user: PapiUser): number {
  return isGroup(user) ? ResourceType.GROUP : ResourceType.USER;
}

export function getUserAvatarSrc(user?: PapiUser) {
  if (!user) {
    return null;
  }

  if (user.usericonDefault || !user.usericon) {
    return null;
  }

  return user.usericon;
}

// check if user has core access
export function getHasCoreAccess(user?: PapiUser): boolean {
  // if coreInfo is available, check the level
  if (user?.coreInfo) {
    return !!user.coreInfo.level;
  }
  // otherwise try to guess based on the user type
  return (
    user?.type === 'core_access' ||
    user?.type === 'core_plus' ||
    user?.type === 'core_pro' ||
    user?.type === 'core_pro_plus' ||
    user?.type === 'core_max'
  );
}
